import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const SortAscending = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<rect
			x="30"
			y="26"
			width="28"
			height="4"
			rx="2"
			transform="rotate(-180 30 26)"
		/>
		<rect
			x="24"
			y="18"
			width="16"
			height="4"
			rx="2"
			transform="rotate(-180 24 18)"
		/>
		<rect
			x="20"
			y="10"
			width="8"
			height="4"
			rx="2"
			transform="rotate(-180 20 10)"
		/>
	</svg>
);

export default SortAscending;
